import React from "react";
import { ReactComponent as EditPen } from "../../../../assets/utils/images/svgs/editPen.svg";
import ReactTableGenericForUsers from "Components/ReactTableGenericForUsers";
import { Card, CardBody } from "reactstrap";
import TextLimit from "Api/TextLimit";

const Records = ({
    data,
    updateDistance,
    openAddressModal,
    pageNumber,
    setPageNumber,
    userTablePageSize,
    pageSizeCount,
    paginate,
    setSearch,
    showLoader,
    sorting,
    setSorting, totalCount
}) => {

    const columns = [
        {
            header: () => 'Vervanger / School',
            accessorKey: 'vFirstName',
            cell: value => (
                <div className="d-flex justify-content-between mx-1" style={{ width: "100%" }}>
                    <span>{window.innerWidth > 1250 ? TextLimit.AfwezigeLimitOptionOne(value.row.original.vFirstName, value.row.original.vMiddleName, value.row.original.vLastName)
                        : TextLimit.AfwezigeLimitOptionTwo(value.row.original.vFirstName, value.row.original.vMiddleName, value.row.original.vLastName)}
                    </span>
                    {data.schoolList && data.schoolList.length > 0 && (
                        <span
                            className="d-flex align-items-center cursor-pointer"
                            onClick={() => openAddressModal(
                                value.row.original.iAdminId,
                                `${value.row.original.vFirstName || ''} ${value.row.original.vMiddleName || ''} ${value.row.original.vLastName || ''}`.trim()
                            )}
                        >
                            <EditPen className="ms-2 blueSVGs" />
                        </span>
                    )}
                </div>
            )
        },
        ...(data?.schoolList || []).map(school => ({
            header: () => (
                <div className="vertical-header">
                    {school?.vSchoolName}
                </div>
            ),

            accessorKey: `distance_${school.iSchoolId}`,
            minSize: 50,      // minimum width
            size: 50,         // initial width
            maxSize: 70,
            cell: (value) => (
                <div className="d-flex " style={{ minWidth: "40px" }}>
                    <input className="distance-input" defaultValue={value.row.original.distance[school.iSchoolId]}
                        onChange={(e) => {
                            updateDistance(e.target.value, value.row.original.iAdminId, school.iSchoolId)
                        }}
                    />
                </div>
            )
        }))
    ];

    return (
        <>
            <Card className="main-card mb-3">
                <CardBody className="p-3 table-responsive">
                    <ReactTableGenericForUsers
                        data={data.adminData}
                        columns={columns}
                        tableClassName="mb-0 table table-borderless table-sm table-hover distance-table"
                        totalPageCount={data?.pageCount ?? 0}
                        pageNumber={pageNumber}
                        setPageNumber={setPageNumber}
                        paginate={paginate}
                        userTablePageSize={userTablePageSize}
                        pageSizeCount={pageSizeCount}
                        filterList={(val) => {
                            if (val !== undefined) {
                                setPageNumber(1)
                                setSearch(val);
                            }
                        }}
                        backendSorting={true}
                        backendSortingState={sorting}
                        updateSortingHandler={(key, order) => setSorting({ key, order })}
                        showLoader={showLoader}
                        count={totalCount}
                    />


                </CardBody>
            </Card>
        </>
    );
};
export default Records;